import { GET_GROUP_LIST, GET_USER_LIST, GET_GROUP_UNREAD_MESSAGE_COUNT, GET_MESSAGE_LIST, GET_MAIN_GROUP_USER_LIST, GET_BOOKING_LIST } from "../constants";
import axios from "axios";
import { ApiCall } from "../../utils"

export const getUserList = (cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    
    const result = await ApiCall.get("/chatGroup/recent/user_list", token);

    dispatch({ type: GET_USER_LIST, payload: result.data });
    cb(result);
  } catch (error) {}
};

export const getGroupList = (cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get(`/chatGroup/mainGroup`, token );
    
    dispatch({ type: GET_GROUP_LIST, payload: result.data });
    cb(result);
  } catch (error) {}
};

export const getGroupUnreadMessageCount = () => async (dispatch, getState) => {
  try {
    const {
      auth: { company, email, token },
    } = getState();

    const payload = {
      email: email,
      company_id: company.id,
    };

    let groupSource = axios.CancelToken.source();
    const result = await ApiCall.get(
      "/chat/group/unread_message_count",
      token
    );
    dispatch({ type: GET_GROUP_UNREAD_MESSAGE_COUNT, payload: result.data });
  } catch (error) {}
};

export const getGroupMessageList = (payload, page, pageLimit, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
      chat: { messagesList }
    } = getState();
    const result = await ApiCall.post(`/chat/group/messages?page=${page}&page_size=${pageLimit}`, payload, token);
    dispatch({ type: GET_MESSAGE_LIST, payload: { message: [...messagesList, ...result.data.message], totalPages: result.data.totalPages, currentPage: parseInt(result.data.currentPage) } });
    cb(result)
  } catch (error) {
    cb(error)
  }
};

export const getUserMessageList = (payload, page, pageLimit, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
      chat: { messagesList }
    } = getState();
    const result = await ApiCall.post(`/chat/user/messageList?page=${page}&page_size=${pageLimit}`, payload, token)
    dispatch({ type: GET_MESSAGE_LIST, payload: { message: [...messagesList, ...result.data.message], totalPages: result.data.totalPages, currentPage: parseInt(result.data.currentPage) } });
    cb(result)
  } catch (error) {
    cb(error)
  }
};

export const getMainGroupUserList = (payload) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/chatGroup/mainGroup/user_info", payload, token)
    dispatch({ type: GET_MAIN_GROUP_USER_LIST, payload: result.data });
  } catch (error) {}
};

export const createSubGroup = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/chatGroup/subGroup", payload, token);
    cb(result);
  } catch (error) {}
};

export const updateSubGroup = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/chatGroup/subGroup", payload, token)
    cb(result);
  } catch (error) {}
};

export const getBookingList = () => async (dispatch, getState) => {
  try {
    const {
      auth: { company, email, token },
    } = getState();
    const result = await ApiCall.get(`/chatGroup/booklist/company`, token )
    dispatch({ type: GET_BOOKING_LIST, payload: result.data });
  } catch (error) {}
};

export const createMainGroup = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/chatGroup/mainGroup", payload, token)
    cb(result);
  } catch (error) {}
};

export const getMainGroupIds = (cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get(`/chatGroup/main_group_ids`, token)
    cb(result);
  } catch (error) {}
};

export const chatGroupUserList = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/chatGroup/userList", payload, token);
    cb(result);
  } catch (error) {}
};
